import { ZViewSnapshotMongoDocument } from "./mongodocuments/viewMongoDocument.schema";
export const ZViewSnapshotState = ZViewSnapshotMongoDocument.pick({ view: true, context: true });
// The server supplies identity, kind and audit metadata.
export const ZCreateSharedViewInput = ZViewSnapshotMongoDocument.pick({
    projectNo: true,
    view: true,
    context: true,
});
